import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UploadPictureModalComponent } from '../components/upload-picture-modal/upload-picture-modal.component';
import { BaseModalSize } from '@shared/ui/modal';
import { UploadImageService } from './upload-image.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable({
  providedIn: 'root',
})
export class UploadImageLayoutModalService {
  private ref!: DynamicDialogRef | null;

  constructor(public dialogService: DialogService, private uploadImageService: UploadImageService) {}

  openUploadOfficerPictureModal(): Observable<boolean> {
    this.ref = this.dialogService.open(UploadPictureModalComponent, {
      data: { uploadImageService: this.uploadImageService },
      width: BaseModalSize.Large,
      modal: true,
    });

    return new Observable<boolean>((observer) => {
      this.ref?.onClose.subscribe((result) => {
        observer.next(!!result);
        observer.complete();
      });
    });
  }
}
